"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;
var _default = {
  flag: !0,
  flageuro: !0,
  flagus: !0,
  flagaus: !0,
  flagbr: !0,
  flagch: !0,
  flagcz: !0,
  flagde: !0,
  flagdu: !0,
  flages: !0,
  flagfr: !0,
  flaggen: !0,
  flagit: !0,
  flagjp: !0,
  flagkr: !0,
  flagpl: !0,
  flagru: !0,
  flagtr: !0,
  flagsg: !0,
  flaguk: !0,
  shootstacolour: !0,
  robot: !0,
  wistia: !0,
  brightcove: !0,
  youtube: !0,
  twitter2: !0,
  facebook2: !0
};
exports["default"] = _default;